// file: src/App.jsx
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import AdminRoutes from "./routes/AdminRoutes";
import LandlordRoutes from "./routes/LandlordRoutes";
import TowingRoutes from "./routes/TowingRoutes";
import { installGlobal401Watch } from "./auth/session";

export default function App() {
  // Install the 401 watcher once at app boot.
  useEffect(() => {
    installGlobal401Watch();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Towing group */}
          <Route path="/towing/*" element={<TowingRoutes />} />

          {/* Landlord group */}
          <Route path="/landlord/*" element={<LandlordRoutes />} />

          {/* Admin group */}
          <Route path="/admin/*" element={<AdminRoutes />} />

          {/* App fallback */}
          <Route path="*" element={<Navigate to="/towing/login" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}
